import React, { ReactNode } from 'react';
import { Typography } from 'antd';

import { ButtonGroup } from '@common/components';

export const TitleAndActions = ({
  title,
  children,
  actions,
}: React.PropsWithChildren<{
  title: string;
  actions?: ReactNode;
}>) => (
  <section className="TitleAndActions">
    <Typography.Title level={2} className="title">
      {title}
    </Typography.Title>
    <div className="content">{children}</div>
    <ButtonGroup>{actions}</ButtonGroup>
    <style jsx>
      {`
        .TitleAndActions {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 2rem;
          margin-top: 1rem;
        }
        .TitleAndActions :global(.title) {
          margin-bottom: 0;
          padding-right: 2rem;
        }
        .TitleAndActions :global(.content) {
          flex-grow: 1;
          margin-right: 2rem;
        }
      `}
    </style>
  </section>
);
